import { createEndpointWarmer } from "@mattfinkel/common-web";
import type { AppCatalogEntry } from "./catalog";

const warmers = new Map<string, () => Promise<void>>();

export function prewarmApp(app: AppCatalogEntry): void {
  if (!app.warmHref) return;

  // The body is deliberately unreadable cross-origin. These endpoints are
  // public and state-free; the request exists only to start the destination's
  // scale-to-zero container before navigation.
  let warm = warmers.get(app.warmHref);
  if (!warm) {
    warm = createEndpointWarmer({
      url: app.warmHref,
      init: { mode: "no-cors", credentials: "omit" },
    });
    warmers.set(app.warmHref, warm);
  }
  void warm();
}

export function resetPrewarmStateForTest(): void {
  warmers.clear();
}
